import {Produs} from './structura_produs';

export const listaProduse: Produs[] = [
    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/gard_valuri.jpg', '../../../assets/products/gard_valuri_2.jpg'],
        description: 'Plăci produse din ciment performant, armate cu fier beton Ø 6 ce oferă o rezistență superioară perfecte ' +
            'pentru îngrădirea curții. Sunt incluse plăcile, un stâlp și un capac pentru stâlp',
        name: 'Gard de beton 3D',
        detailsPrices: ' 135lei / 170lei',
        height: '150cm / 200cm',
        thickness: '-',
        width: '-',
        length: '200 cm',
        price: '135',
        purpose: 'Casă și Grădină',
        priceUnitMeasure: 'Lei / ml',
        tags: ['gard', 'garduri', 'placi', 'beton', 'armat', '3D', 'ondulat', 'valuri'],
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/gard_timurlea2.jpg', '../../../assets/products/gard_timurlea2_2.jpg'],
        description: 'Plăci produse din ciment performant, armate cu fier beton Ø 6 ce oferă o rezistență superioară perfecte ' +
            'pentru îngrădirea curții. Sunt incluse plăcile, un stâlp și un capac pentru stâlp',
        name: 'Gard de beton Timurlea 2',
        detailsPrices: '130lei / 162.5lei',
        height: '150cm / 200cm',
        thickness: '-',
        width: '-',
        length: '200 cm',
        price: '130',
        purpose: 'Casă și Grădină',
        priceUnitMeasure: 'Lei / ml',
        tags: ['gard', 'garduri', 'placi', 'beton', 'gard de beton', 'armat', 'timurlea 2']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/gard_lemn.jpg'],
        description: 'Plăci produse din ciment performant, armate cu fier beton Ø 6 ce oferă o rezistență superioară perfecte ' +
            'pentru îngrădirea curții. Sunt incluse plăcile, un stâlp și un capac pentru stâlp',
        name: 'Gard de beton Lemn Suprapus',
        detailsPrices: '260lei / 300lei per lacră',
        height: '150cm / 180cm',
        thickness: '-',
        width: '-',
        length: '190 cm',
        price: '130',
        purpose: 'Casă și Grădină',
        priceUnitMeasure: 'Lei / ml',
        tags: ['gard', 'garduri', 'placi', 'beton', 'gard de beton', 'armat', 'lemn suprapus'],
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/gard_flori.jpg'],
        description: 'Plăci produse din ciment performant, armate cu fier beton Ø 6 ce oferă o rezistență superioară perfecte ' +
            'pentru îngrădirea curții. Sunt incluse plăcile, un stâlp și un capac pentru stâlp',
        name: 'Gard de beton Flori',
        detailsPrices: '130lei / 162.5lei',
        height: '150cm / 200cm',
        thickness: '-',
        width: '-',
        length: '200 cm',
        price: '130',
        purpose: 'Casă și Grădină',
        priceUnitMeasure: 'Lei / ml',
        tags: ['gard', 'garduri', 'placi', 'beton', 'gard de beton', 'armat', 'flori'],
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/gard_timurlea1.jpg'],
        description: 'Plăci produse din ciment performant, armate cu fier beton Ø 6 ce oferă o rezistență superioară perfecte ' +
            'pentru îngrădirea curții. Sunt incluse plăcile, un stâlp și un capac pentru stâlp',
        name: 'Gard de beton Timurlea 1',
        detailsPrices: '130lei / 162.5lei',
        height: '150cm / 200cm',
        thickness: '-',
        width: '-',
        length: '200 cm',
        price: '130',
        purpose: 'Casă și Grădină',
        priceUnitMeasure: 'Lei / ml',
        tags: ['gard', 'garduri', 'placi', 'beton', 'gard de beton', 'armat', 'timurlea 1']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/gard_piatra.jpg', '../../../assets/products/gard_piatra_2.jpg'],
        description: 'Plăci produse din ciment performant, armate cu fier beton Ø 6 ce oferă o rezistență superioară perfecte ' +
            'pentru îngrădirea curții. Sunt incluse plăcile, un stâlp și un capac pentru stâlp',
        name: 'Gard de beton Piatra',
        detailsPrices: '130lei / 162.5lei',
        height: '150cm / 200cm',
        thickness: '-',
        width: '-',
        length: '200 cm',
        price: '130',
        purpose: 'Casă și Grădină',
        priceUnitMeasure: 'Lei / ml',
        tags: ['gard', 'garduri', 'placi', 'beton', 'gard de beton', 'armat', 'piatra'],
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/gard_lemn_decojit.jpg'],
        description: 'Plăci produse din ciment performant, armate cu fier beton Ø 6 ce oferă o rezistență superioară perfecte ' +
            'pentru îngrădirea curții. Sunt incluse plăcile, un stâlp și un capac pentru stâlp',
        name: 'Gard de beton Lemn Rotund',
        detailsPrices: '130lei / 162.5lei',
        height: '150cm / 200cm',
        thickness: '-',
        width: '-',
        length: '200 cm',
        price: '130',
        purpose: 'Casă și Grădină',
        priceUnitMeasure: 'Lei / ml',
        tags: ['gard', 'garduri', 'placi', 'beton', 'gard de beton', 'armat', 'Lemn'],
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/gard_scandura_impletita.jpg', '../../../assets/products/gard_scandura_impletita_2.jpg'],
        description: 'Plăci produse din ciment performant, armate cu fier beton Ø 6 ce oferă o rezistență superioară perfecte ' +
            'pentru îngrădirea curții. Sunt incluse plăcile, un stâlp și un capac pentru stâlp',
        name: 'Gard de beton Scandura',
        detailsPrices: '130lei / 162.5lei',
        height: '150cm / 200cm',
        thickness: '-',
        width: '-',
        length: '200 cm',
        price: '130',
        purpose: 'Casă și Grădină',
        priceUnitMeasure: 'Lei / ml',
        tags: ['gard', 'garduri', 'placi', 'beton', 'gard de beton', 'armat', 'scandura', 'lemn', 'impletit'],
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/gard_geometric.jpg'],
        description: 'Plăci produse din ciment performant, armate cu fier beton Ø 6 ce oferă o rezistență superioară perfecte ' +
            'pentru îngrădirea curții. Sunt incluse plăcile, un stâlp și un capac pentru stâlp',
        name: 'Gard de beton Geometric',
        detailsPrices: '130lei / 162.5lei',
        height: '150cm / 200cm',
        thickness: '-',
        width: '-',
        length: '200 cm',
        price: '130',
        purpose: 'Casă și Grădină',
        priceUnitMeasure: 'Lei / ml',
        tags: ['gard', 'garduri', 'placi', 'beton', 'gard de beton', 'armat', 'geometric', 'romb'],
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/boltari20.jpg', '../../../assets/products/boltari12.jpg'],
        description: 'Soluția perfectă pentru construirea pereților și a gardurilor. Sunt produși din ciment performant ce le oferă o ' +
            'rezistență superioară.',
        name: 'Boltari',
        detailsPrices: '4.30lei / 4.80lei / 5.30lei',
        height: '20 cm',
        thickness: '-',
        width: '12cm / 15cm / 20cm',
        length: '40 cm',
        price: '4.80',
        purpose: 'Zidărie',
        priceUnitMeasure: 'Lei / buc',
        tags: ['boltari', 'boltar'],
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/capac_neted_gri.jpg'],
        description: 'Produse din ciment performant, cu o rezistență superioară, capacele constituie ' +
            'un accesoriu indispensabil pentru garduri. Culorile disponibile sunt gri, roșu, maro, galben.',
        name: 'Capac neted stalp gard',
        detailsPrices: '15lei / 17lei / 19lei / 22lei / 25lei / 30lei / 35lei pe culoarea gri',
        height: '-',
        thickness: '-',
        width: '25cm / 30cm / 35cm / 40cm / 45cm / 50cm / 60cm',
        length: '25cm / 30cm / 35cm / 40cm / 45cm / 50cm / 60cm',
        price: '15',
        purpose: 'Accesoriu gard',
        priceUnitMeasure: 'Lei / buc',
        tags: ['capace', 'capac', 'stalp', 'gard', 'neted', 'palarii', 'caciuli', 'palarie', 'caciula', 'rosu', 'gri']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/capac_bob_rosu.jpg'],
        description: 'Produse din ciment performant, cu o rezistență superioară, capacele constituie ' +
            'un accesoriu indispensabil pentru garduri. Culorile disponibile sunt gri, roșu, maro, galben.',
        name: 'Capac bob stalp gard',
        detailsPrices: '-',
        height: '-',
        thickness: '-',
        width: '40 cm',
        length: '40 cm',
        price: '22',
        purpose: 'Accesoriu gard',
        priceUnitMeasure: 'Lei / buc',
        tags: ['capace', 'capac', 'stalp', 'gard', 'bob', 'palarii', 'caciuli', 'palarie', 'caciula', 'rosu', 'gri']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/capac_floare_gri.jpg'],
        description: 'Produse din ciment performant, cu o rezistență superioară, capacele constituie ' +
            'un accesoriu indispensabil pentru garduri. Culorile disponibile sunt gri, roșu, maro, galben.',
        name: 'Capac floare stalp gard',
        detailsPrices: '19lei / 22lei/ 25lei',
        height: '-',
        thickness: '-',
        width: '35cm / 40cm / 45cm',
        length: '35cm /40cm / 45cm',
        price: '19',
        purpose: 'Accesoriu gard',
        priceUnitMeasure: 'Lei / buc',
        tags: ['capace', 'capac', 'stalp', 'gard', 'floare', 'palarii', 'caciuli', 'palarie', 'caciula', 'rosu', 'gri']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/capac_ascutit_rosu.jpg'],
        description: 'Produse din ciment performant, cu o rezistență superioară, capacele constituie ' +
            'un accesoriu indispensabil pentru garduri. Culorile disponibile sunt gri, roșu, maro, galben.',
        name: 'Capac ascutit stalp gard',
        detailsPrices: '19lei gri / 22 lei colorat',
        height: '-',
        thickness: '-',
        width: '35 cm',
        length: '35 cm',
        price: '19',
        purpose: 'Accesoriu gard',
        priceUnitMeasure: 'Lei / buc',
        tags: ['capace', 'capac', 'stalp', 'gard', 'ascutit', 'palarii', 'caciuli', 'palarie', 'caciula', 'rosu', 'gri']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/coama_50x30.jpg', '../../../assets/products/coama_50x30_rosu.jpg',
            '../../../assets/products/coama_40x27.jpg', '../../../assets/products/coama_40x27_rosu.jpg'],
        description: 'Produse din ciment performant, cu o rezistență superioară, capacele constituie ' +
            'un accesoriu indispensabil pentru garduri. Culorile disponibile sunt gri, roșu, maro, galben.',
        name: 'Coama neteda gard',
        detailsPrices: '15lei gri / 18lei colorat',
        height: '-',
        thickness: '-',
        width: '18cm / 27cm',
        length: '50cm / 40cm',
        price: '25',
        purpose: 'Accesoriu gard',
        priceUnitMeasure: 'Lei / buc',
        tags: ['capace', 'capac', 'stalp', 'gard', 'neted', 'palarii', 'caciuli', 'palarie', 'caciula', 'coama', 'coame', 'rosie', 'gri']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/coama_40x35_bob.jpg', '../../../assets/products/coama_40x35_rosu.jpg'],
        description: 'Produse din ciment performant, cu o rezistență superioară, capacele constituie ' +
            'un accesoriu indispensabil pentru garduri. Culorile disponibile sunt gri, roșu, maro, galben.',
        name: 'Coama bob gard',
        detailsPrices: '21lei gri / 24lei colorat',
        height: '-',
        thickness: '-',
        width: '35 cm',
        length: '40 cm',
        price: '21',
        purpose: 'Accesoriu gard',
        priceUnitMeasure: 'Lei / buc',
        tags: ['capace', 'capac', 'stalp', 'gard', 'bob', 'palarii', 'caciuli', 'palarie', 'caciula', 'coama', 'coame', 'rosie', 'gri']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/coama_lunga.jpg'],
        description: 'Produse din ciment performant, cu o rezistență superioară, capacele constituie ' +
            'un accesoriu indispensabil pentru garduri. Culorile disponibile sunt gri, roșu, maro, galben.',
        name: 'Coama lunga gard',
        detailsPrices: '-',
        height: '-',
        thickness: '-',
        width: '19 cm',
        length: '190 cm',
        price: '60',
        purpose: 'Accesoriu gard',
        priceUnitMeasure: 'Lei / buc',
        tags: ['capace', 'capac', 'stalp', 'gard', 'lunga', 'palarii', 'caciuli', 'palarie', 'caciula', 'coama', 'coame', 'gri']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/fantana_arteziana_mica.png'],
        description: 'Fântâna arteziană creează o atmosfera deosebită în gradina dumneavoastră. ' +
            'Sunetul liniștitor al apei vă oferă senzația de calm și echilibru.',
        name: 'Fantana Arteziana mica',
        detailsPrices: '+ 150 lei pompa de recirculare',
        height: '170 cm',
        thickness: '-',
        width: '90 cm',
        length: '-',
        price: '900',
        purpose: 'Grădină',
        priceUnitMeasure: 'Lei',
        tags: ['fantana', 'arteziana', 'fantani', 'arteziene', 'de decor', 'gradina'],
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/fantana_arteziana_mare.jpg'],
        description: 'Credem în calitatea produselor romanești așa că am creat aceasta fântână perfectă pentru gradina ta.' +
            ' Fântâna arteziană creează o atmosferă deosebită, iar sunetul liniștitor al apei vă oferă senzația de calm și echilibru.',
        name: 'Fantana Arteziana mare',
        detailsPrices: '+ 300 lei pompa de recirculare',
        height: '200 cm',
        thickness: '-',
        width: '200 cm',
        length: '-',
        price: '2.500',
        purpose: 'Grădină',
        priceUnitMeasure: 'Lei',
        tags: ['fantana', 'arteziana', 'fantani', 'arteziene', 'de decor', 'gradina'],
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/pavele_harta_gri.jpg', '../../../assets/products/pavele_harta_rosu.jpg'],
        description: 'Produse din ciment performant ce le oferă o rezistență superioară, pavelele Hartă' +
            'reprezintă soluția perfectă pentru pavarea pietonală. Culorile disponibile sunt gri, roșu, maro, galben, portocaliu.',
        name: 'Pavele Harta',
        detailsPrices: '42lei gri / 45lei colorat',
        height: '-',
        thickness: '3 cm',
        width: '30 cm',
        length: '30 cm',
        price: '42',
        purpose: 'Alee / Grădină',
        priceUnitMeasure: 'Lei / mp',
        tags: ['pavea', 'pavele', 'pavaj', 'harta', 'alee', 'dala', 'dale', 'lespede', 'lespezi', 'gri', 'rosu']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/pavele_romanita.jpg'],
        description: 'Produse din ciment performant ce le oferă o rezistență superioară, pavelele Florale' +
            'reprezintă soluția perfectă de pavaj rutier. Culorile disponibile sunt gri, roșu, maro, galben, portocaliu.',
        name: 'Pavele Florale',
        detailsPrices: '-',
        height: '-',
        thickness: '4.5 cm',
        width: '-',
        length: '-',
        price: '53',
        purpose: 'Alee / Grădină',
        priceUnitMeasure: 'Lei / mp',
        tags: ['pavea', 'pavele', 'pavaj', 'florale', 'alee', 'dala', 'dale', 'lespede', 'lespezi', 'gri', 'rosu']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/pavele_dale_45x45.jpg'],
        description: 'Produse din ciment performant ce le oferă o rezistență superioară, pavelele lespede' +
            'reprezintă soluția perfectă de pavaj rutier. Culorile disponibile sunt gri, roșu, maro, galben, portocaliu.',
        name: 'Pavele lespede',
        detailsPrices: '12lei gri / 13lei colorat',
        height: '-',
        thickness: '5.5 cm',
        width: '45 cm',
        length: '45 cm',
        price: '12',
        purpose: 'Alee pietonala si rutiera / Grădină',
        priceUnitMeasure: 'Lei / buc',
        tags: ['pavea', 'pavele', 'pavaj', 'alee', 'dala', 'dale', 'lespede', 'lespezi', 'gri', 'rosu']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/pavele_yeti_gri.jpg', '../../../assets/products/pavele_yeti_rosu.jpg'],
        description: 'Produse din ciment performant ce le oferă o rezistență superioară, pavelele Yeti' +
            'reprezintă soluția perfectă de pavaj pietonal. Culorile disponibile sunt gri, roșu, maro, galben, portocaliu.',
        name: 'Pavele Yeti',
        detailsPrices: '13lei gri / 15lei colorat',
        height: '-',
        thickness: '5 cm',
        width: '-',
        length: '-',
        price: '13',
        purpose: 'Alee / Grădină',
        priceUnitMeasure: 'Lei / buc',
        tags: ['pavea', 'pavele', 'pavaj', 'yeti', 'picior', 'alee', 'dala', 'dale', 'lespede', 'lespezi', 'gri', 'rosu']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/bordura.jpg'],
        description: 'Ideale pentru delimitarea aleilor de acces în curte sau din gradină, bordurile Salbero ' +
            'sunt disponibile într-o gamă variată de culori (gri, roșu, maro, galben) pentru a se potrivi cu orice tip de alee exterioară.',
        name: 'Bordura',
        detailsPrices: '6lei/ 7lei/ 8lei pe culoarea gri',
        height: '12cm / 15cm / 20cm',
        thickness: '6cm / 6.5cm / 7cm',
        width: '-',
        length: '50 cm',
        price: '6',
        purpose: 'Delimitare alee / Grădină',
        priceUnitMeasure: 'Lei / buc',
        tags: ['bordura', 'borduri', 'gri', 'rosu', 'pavele', 'pavea', 'pavaj', 'dale']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/spalieri.jpg'],
        description: 'Ideali pentru susținerea viței de vie și pentru garduri, spalierii sunt armați cu fier beton Ø6mm',
        name: 'Spalieri',
        detailsPrices: '32lei / 35lei / 39lei',
        height: '-',
        thickness: '-',
        width: '-',
        length: '230cm / 250cm / 270cm',
        price: '32',
        purpose: 'Vie / Stalpi',
        priceUnitMeasure: 'Lei / buc',
        tags: ['spalieri', 'spalier', 'stalpi', 'gard', 'vie', 'pentru', 'vita de vie']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/piatra_z.jpg'],
        description: 'Elemente pentru placarea fațadelor exterioare.',
        name: 'Piatra decorativa Z',
        detailsPrices: '-',
        height: '-',
        width: '20 cm',
        thickness: '3 cm',
        length: '53 cm',
        price: '42',
        purpose: 'Casă',
        priceUnitMeasure: 'Lei / buc',
        tags: ['piatra', 'decorativa', 'pietre', 'decorative', 'soclu', 'casa', 'pentru', 'z']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/piatra_p.jpg'],
        description: 'Elemente pentru placarea fațadelor exterioare.',
        name: 'Piatra decorativa P',
        detailsPrices: '-',
        height: '-',
        thickness: '-',
        width: '-',
        length: '-',
        price: '40',
        purpose: 'Casă',
        priceUnitMeasure: 'Lei / buc',
        tags: ['piatra', 'decorativa', 'pietre', 'decorative', 'soclu', 'casa', 'pentru', 'de', 'p']
    },

    {
        productCode: 'CD93214121',
        urlImage: ['../../../assets/products/piatra_d.jpg'],
        description: 'Elemente pentru placarea fațadelor exterioare.',
        name: 'Piatra decorativa D',
        detailsPrices: '-',
        height: '-',
        thickness: '-',
        width: '-',
        length: '-',
        price: '40',
        purpose: 'Casă',
        priceUnitMeasure: 'Lei / buc',
        tags: ['piatra', 'decorativa', 'pietre', 'decorative', 'soclu', 'casa', 'pentru', 'de', 'd']
    },
];
